export const isRightAligned = (alignment) => {
    if (!alignment)
        return false;
    return alignment.toUpperCase() === 'RIGHT';
};
export const isLeftAligned = (alignment) => {
    if (!alignment)
        return false;
    return alignment.toUpperCase() === 'LEFT';
};
export const isCenterAligned = (alignment) => {
    if (!alignment)
        return false;
    return alignment.toUpperCase() === 'CENTER';
};
export const isLogoTypeSmall = (field) => {
    const value = field && field.value;
    return value.toUpperCase() === 'SMALL';
};
export const getLinkTarget = (linkType) => {
    return linkType === 'external' ? '_blank' : '_self';
};
export const isContentEntering = (state) => {
    return state === 'entering' || state === 'entered';
};
